import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const ContactInfosWrapper = ({ children, testId }) => (_jsx(Box, { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", width: "100%", testId: testId, children: children }));
